<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { Api } from './service/api'
import VueMeta from 'vue-meta'
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
Vue.use(VueMeta)
const store = new Vuex.Store({
    //state存储应用层的状态
    state:{
        count:5  //总数：5
    },
    mutations:{
        increment(state,value){
            state.count += value;
        }
    }
});

export default {
  name: 'App',
  metaInfo:{
      title :'SEO_网站优化_整站优化_百度快速排名软件_关键词排名查询工具_爱排名网络营销推广平台',
      keywords : 'seo,网站优化,整站优化,爱排名,快速排名,百度快速排名,关键词排名,排名查询,百度排名查询,SEO工具,网络营销,网络推广,搜索引擎排名,seo网站优化,百度快速排名软件,seo优化,关键词排名,关键词优化,排名系统,快速排名系统,关键词排名系统',
      description: '【爱排名】专研SEO技术十二年,自主研发智能网站排名权重优化系统,对百度、360、搜狗等搜索引擎关键词排名先达标后扣费！系统操作简单，只需要添加网址和关键词的一步操作就能坐等快速排名效果！使您的网站优化省时、省事、更省钱！目前系统关键词排名达标词30万+,智能监控系统让关键词排名效果以及费用消耗一目了然'
  },
  data() {
    return {

    }
  },
  methods: {
    setTitle() {

    },
    shangqiao(){


    }
  },
  mounted() {
      console.log('store',this.$store)
     this.shangqiao()
    if(this.$route.query && this.$route.query.code){
      document.cookie=`code=${this.$route.query.code}`
    }
    this.setTitle()
  }
}
</script>

<style lang='scss'>
@import './assets/style/common';
@import './assets/style/mixin';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 15px;
  background: #f7f7f7;
}
</style>



// WEBPACK FOOTER //
// src/App.vue